import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'fcp-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
})
export class SearchResultsComponent implements OnInit {
  @Input() public data: any;
  @Input() public page: number;
  @Output() public clicked: EventEmitter<any> = new EventEmitter();
  @Output() public clickedPage: EventEmitter<any> = new EventEmitter();

  public config = {
    id: 'custom',
    itemsPerPage: 3,
    currentPage: 1
  };

  public goToPage(url) {
    this.clicked.emit(url);
  }

  public format(value: string) {
    let str = value;
    if (str.length > 90) {
      str = str.substr(0, 90) + '...';
    }
    return str;
  }

  public changePage(page) {
    this.clickedPage.emit(page);
    this.config.currentPage = page;
  }

  ngOnInit() {
    this.config.currentPage = this.page;
  }
}
